import React, { useRef, useState } from 'react';
import IndigoImg from '../../assets/images/HPIndigo.png';
import englishIcon from '../../assets/images/reino-unido.png';
import spanishIcon from '../../assets/images/espana.png';
import portugueseIcon from '../../assets/images/portugal.png';
import Carousel from 'react-bootstrap/Carousel';
import {IconBell, IconChevronLeft, IconChevronRight, Modal , IconDownload,Select , Button ,Tooltip, Search,Table,  ConfirmationModal, IconPencil, ContextualMenu, IconPerson, IconUpload, IconTrash, Tabs, IconChevronDoubleLeft  } from "@veneer/core";
import trainingVideo from '../../assets/video/TrainingVideo.mp4';
import ReactPlayer from 'react-player'
import { useTranslation } from 'react-i18next';
import { Tab } from 'react-bootstrap';


const Home = () => {
  const { t, i18n } = useTranslation();
  const [videoInterval, setVideoInterval] = useState(7000);
  const playerRef = useRef(null);
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const [showNotifModal, setShowNotifModal] = useState(currentUser.notifications.length > 0);

  //function to set the video to 1 sec
  const handleOnDuration = (e) => {
    playerRef.current.seekTo(1);
  }
  
  //tabs
  const [activeTabIndex, setactiveTabIndex] = useState(0);
  const selectTab = (event) => (index) => {
    setactiveTabIndex(index);
  };
  const width_proportion = '60%';
  const margin_left = '20%';

  return (
    <div>
      <div>
        <div style={{ textAlign: "center", fontFamily: "HP Simplified, Arial, sans-serif", marginTop: '20px' }}><h3>iPSP Indigo Productivity & Supplies Portal</h3></div>
        <div style={{ textAlign: "center", fontSize: "16px", marginTop: '15px', padding: '0px 15%' }}>
          {t('hometext1')} {t('hometext2')}
        </div>
        <br /><br />

        <Carousel
          interval={7000}
          prevIcon={<IconChevronLeft size={50} />}
          nextIcon={<IconChevronRight size={50} />}
          pause={'hover'}
        >
          <Carousel.Item interval={videoInterval}>
            <ReactPlayer
              url={trainingVideo}
              width='70%'
              height='70%'
              controls={true}
              style={{ display: 'block', margin: 'auto', paddingBottom: '30px' }}
              onPlay={() => setVideoInterval(960000)}
              onPause={() => setVideoInterval(7000)}
              ref={playerRef}
              onDuration={handleOnDuration}
            />
          </Carousel.Item>
          <Carousel.Item>
            <img style={{ display: 'block', margin: 'auto' }} width="36%" height="36%" src={IndigoImg} alt="HP"></img>
          </Carousel.Item>
        </Carousel>

        <div style={{ textAlign: "center" }}>
          <b>{t('hometext3')}</b> <a href="https://www8.hp.com/br/pt/industrial-printers/indigo-digital-presses.html?jumpid=va_tczqgm62aw">hp.com/indigo</a>
        </div>

      </div>
      
      <Modal
        
        closeButton
        show={showNotifModal}
        onClose={() => setShowNotifModal(false)}
        css={{
          '.vn-modal--content': {
              width: "72% !important",
              "margin-left": "15% !important",
          },
          'p': {
              fontSize: "20px",
              marginTop: "10px",
              fontWeight: "none",
          }
        }}
        closeOnBlur={false}
      >
        <div style={{ textAlign: 'center' }}>
          <IconBell style={{ margin: 'auto' }} filled size={50} color="colorYellow3" display="block" />
        </div>
        
        <Tabs
          controlId="default"
          onChangeTab={selectTab()}
          selectedTabId={activeTabIndex}
          tabs={
            [
              { 
                id: 0, 
                label: 
                  <>
                    <img src={englishIcon} alt="Flag of United Kingdom" width="50%"></img>
                  </>,
                content: 
                  currentUser.notifications.map(notif => {
                    return (
                      <>
                        <h3 style={{ display: 'inline', verticalAlign: 'top', marginLeft: '10px' }}>We have some news for you</h3>
                        <br/>
                        {notif.messageEN.split('\r\n').map((en, i) => (<p key={i} dangerouslySetInnerHTML={{ __html: en }} />))}
                      </>
                    );
                  })
              },
              { 
                id: 1, 
                label: 
                  <>
                    <img src={spanishIcon} alt="Flag of Spain" width="50%"></img>
                  </>,
                content: 
                  currentUser.notifications.map(notif => {
                    return (
                      <>
                        <h3 style={{ display: 'inline', verticalAlign: 'top', marginLeft: '10px' }}>Tenemos noticias para usted</h3>
                        <br/>
                        {notif.messageES.split('\r\n').map((es, i) => (<p key={i} dangerouslySetInnerHTML={{ __html: es }} />))}
                      </>
                    );
                  })
              },
              { 
                id: 2, 
                label: 
                  <>
                    <img src={portugueseIcon} alt="Flag of Portugal" width="50%"></img>
                  </>, 
                content: 
                  currentUser.notifications.map(notif => {
                    return (
                      <>
                        <h3 style={{ display: 'inline', verticalAlign: 'top', marginLeft: '10px' }}>Temos notícias para você</h3>
                        <br/>
                        {notif.messagePT.split('\r\n').map((pt, i) => (<p key={i} dangerouslySetInnerHTML={{ __html: pt }} />))}
                      </>
                    );
                  })
              }  
            ]
          }
          
        />
  
        
      </Modal>

    </div>
  );
}

export default Home;
